/**
 * @generated SignedSource<<acff010cd9f3e6ed199f7d968c2fa83c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "colorId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "colorId",
        "variableName": "colorId"
      }
    ],
    "concreteType": "Color",
    "kind": "LinkedField",
    "name": "color",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QColorQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QColorQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf4385cffc5aa6a92846d2ecc8dc0c43",
    "id": null,
    "metadata": {},
    "name": "QColorQuery",
    "operationKind": "query",
    "text": "query QColorQuery(\n  $colorId: ID!\n) {\n  color(colorId: $colorId) {\n    id\n    name\n    value\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "3e2603d59751693f41d1fd1c5d20ecaa";

export default node;
